import React from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

interface GradientOptions {
  topColor: string;
  bottomColor?: string;
}

interface Props {
  title: string;
  value: string;
  gradientOptions: GradientOptions;
}

const InfoPanel = (props: Props) => {
  const {
    title,
    value,
    gradientOptions: { topColor, bottomColor }
  } = props;
  const classes = useStyles({
    topColor,
    bottomColor
  });

  return (
    <Paper className={classes.root}>
      <Box className={classes.leftBorder} />
      <Box className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.value}>{value}</Typography>
      </Box>
    </Paper>
  );
};

export default InfoPanel;
